import { render, staticRenderFns } from "./NagorikGames.vue?vue&type=template&id=071751a6&"
import script from "./NagorikGames.vue?vue&type=script&lang=js&"
export * from "./NagorikGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports